import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import SectionContainer from '../LandingPage/components/section/SectionContainer'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <g clip-path="url(#clip0_552_4825)">
      <path d="M10 18H1L1.5 26.5L10 27V18Z" fill="#D4DAE0" />
      <path d="M18 10V7.14286H11.4118L10 5V10H18Z" fill="#D4DAE0" />
      <path
        d="M17.9163 2.33374C17.9163 2.10373 17.7303 1.91692 17.5003 1.91675H10.5003C10.2702 1.91675 10.0833 2.10362 10.0833 2.33374V9.33374C10.0835 9.56371 10.2703 9.74976 10.5003 9.74976H17.5003C17.7302 9.74958 17.9161 9.5636 17.9163 9.33374V2.33374ZM19.4163 9.33374C19.4161 10.392 18.5586 11.2496 17.5003 11.2498H10.5003C9.44187 11.2498 8.58349 10.3921 8.58331 9.33374V2.33374C8.58331 1.27519 9.44176 0.416748 10.5003 0.416748H17.5003C18.5587 0.416924 19.4163 1.2753 19.4163 2.33374V9.33374Z"
        fill="#474C5E"
      />
      <path
        d="M26.083 18.667C26.083 18.437 25.897 18.2502 25.667 18.25H18.667C18.4369 18.25 18.25 18.4369 18.25 18.667V25.667C18.2502 25.897 18.437 26.083 18.667 26.083H25.667C25.8969 26.0828 26.0828 25.8969 26.083 25.667V18.667ZM27.583 25.667C27.5828 26.7253 26.7253 27.5828 25.667 27.583H18.667C17.6086 27.583 16.7502 26.7254 16.75 25.667V18.667C16.75 17.6084 17.6084 16.75 18.667 16.75H25.667C26.7254 16.7502 27.583 17.6086 27.583 18.667V25.667Z"
        fill="#474C5E"
      />
      <path
        d="M9.74969 18.667C9.74969 18.437 9.56365 18.2502 9.33368 18.25H2.33368C2.10356 18.25 1.91669 18.4369 1.91669 18.667V25.667C1.91686 25.897 2.10367 26.083 2.33368 26.083H9.33368C9.56354 26.0828 9.74952 25.8969 9.74969 25.667V18.667ZM11.2497 25.667C11.2495 26.7253 10.392 27.5828 9.33368 27.583H2.33368C1.27524 27.583 0.416863 26.7254 0.416687 25.667V18.667C0.416687 17.6084 1.27513 16.75 2.33368 16.75H9.33368C10.3921 16.7502 11.2497 17.6086 11.2497 18.667V25.667Z"
        fill="#474C5E"
      />
      <path
        d="M21.25 17.5V15.1426C21.2499 15.0035 21.2004 14.8942 21.1426 14.8281C21.0861 14.7637 21.0339 14.75 21 14.75H7C6.96614 14.75 6.91389 14.7637 6.85742 14.8281C6.79958 14.8942 6.75006 15.0035 6.75 15.1426V17.5C6.75 17.9142 6.41421 18.25 6 18.25C5.58579 18.25 5.25 17.9142 5.25 17.5V15.1426C5.25013 14.1945 5.94267 13.25 7 13.25H21C22.0573 13.25 22.7499 14.1945 22.75 15.1426V17.5C22.75 17.9142 22.4142 18.25 22 18.25C21.5858 18.25 21.25 17.9142 21.25 17.5Z"
        fill="#474C5E"
      />
      <path
        d="M13.25 14V11C13.25 10.5858 13.5858 10.25 14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V14C14.75 14.4142 14.4142 14.75 14 14.75C13.5858 14.75 13.25 14.4142 13.25 14Z"
        fill="#474C5E"
      />
    </g>
    <defs>
      <clipPath id="clip0_552_4825">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M13 14.5V2.5C13 2.5 19.5 3.5 22 6C25.0414 9.04138 25 14.5 25 14.5H13Z"
      fill="#D4DAE0"
    />
    <path
      d="M6.5 22.5L3.5 18.5L2.5 14L3 10C3 10 2.98183 14.6524 4.5 17C6.26475 19.7289 9.10583 20.4871 11.5 21.5C15.4654 23.1777 23 21 23 21L18.5 24.5L12 25.5L6.5 22.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M9.32602 2.60156C9.6059 2.59645 9.86765 2.73863 10.0165 2.97363L10.0731 3.0791L10.077 3.08789L10.1053 3.16602C10.2264 3.5565 10.03 3.97331 9.66001 4.13477L9.65903 4.13379L9.36215 4.26855L9.36313 4.26953C7.9885 4.92023 6.76683 5.85665 5.78305 7.0166L5.78403 7.01758L5.56235 7.28809C4.55 8.56423 3.84218 10.0535 3.49399 11.6416L3.49497 11.6426L3.42563 11.9854C3.10863 13.6979 3.21562 15.4625 3.73618 17.125H3.7352L3.83774 17.4355H3.83872C4.37316 18.9753 5.25249 20.3744 6.41196 21.5234L6.66489 21.7656C7.85654 22.8715 9.28642 23.6922 10.8456 24.1631H10.8465L11.1727 24.2559L11.4686 24.3311C12.9532 24.6832 14.4991 24.7136 16.0008 24.418L16.3426 24.3447C17.9309 23.9776 19.4159 23.2514 20.6825 22.2207L20.9334 22.0107C22.1682 20.9412 23.1426 19.6013 23.7801 18.0938L23.8163 18.0176C24.0025 17.6786 24.397 17.5357 24.745 17.6387L24.8192 17.665L24.828 17.6689L24.8993 17.7031C25.2428 17.8908 25.4217 18.3188 25.2547 18.7158L25.2538 18.7168C24.5208 20.45 23.4001 21.9902 21.9803 23.2197L21.6922 23.4619C20.2329 24.6495 18.521 25.4851 16.6903 25.9062L16.6786 25.9092L16.3338 25.9824L16.3231 25.9844C14.4775 26.3498 12.5732 26.2873 10.7586 25.8018L10.7479 25.7988L10.4081 25.7021L10.3973 25.6992V25.6982C8.59555 25.1564 6.94287 24.2089 5.56723 22.9297L5.55942 22.9229L5.30454 22.6787L5.29575 22.6699C3.9577 21.347 2.94194 19.7353 2.32602 17.9609L2.32212 17.9492L2.21176 17.6133L2.20883 17.6035L2.30454 17.5732V17.5723L2.20883 17.6025C1.60926 15.6875 1.48691 13.6539 1.85434 11.6807L1.8563 11.6689L1.92661 11.3232L1.92954 11.3125L2.00864 10.9697C2.43243 9.26298 3.21949 7.66399 4.31723 6.2832L4.32407 6.27441L4.5477 6.00195L4.55551 5.99316L4.78598 5.72754C5.95975 4.41832 7.40351 3.37367 9.02036 2.66797L9.09555 2.63965C9.12086 2.63171 9.14666 2.62534 9.1727 2.62012L9.19223 2.61621L9.32602 2.60156ZM12.1424 13.9355V3.49121C12.1426 3.01602 12.3311 2.5594 12.6678 2.22266L12.7997 2.10352C13.119 1.84195 13.5203 1.69732 13.9364 1.69727C15.5433 1.69727 17.1351 2.01291 18.62 2.62793L19.1698 2.87207C20.4386 3.47241 21.5962 4.2878 22.5907 5.28223L23.0057 5.71777C23.9479 6.75751 24.7058 7.95272 25.244 9.25195C25.8591 10.7369 26.1747 12.3286 26.1747 13.9355C26.1747 14.8646 25.4688 15.6277 24.5643 15.7197L24.3807 15.7295H13.9364C12.9456 15.7294 12.1424 14.9266 12.1424 13.9355ZM13.6424 13.9355C13.6424 14.098 13.7737 14.2294 13.9364 14.2295H24.3807L24.4403 14.2236C24.5743 14.1961 24.6747 14.0776 24.6747 13.9355C24.6747 12.5252 24.3969 11.1289 23.8573 9.82617C23.3852 8.68653 22.721 7.63787 21.8944 6.72559L21.5301 6.34277C20.6576 5.47029 19.642 4.75517 18.5291 4.22852L18.0457 4.01465C16.7431 3.4751 15.3466 3.19727 13.9364 3.19727C13.8777 3.19729 13.8212 3.21514 13.7733 3.24707L13.7284 3.2832C13.6736 3.33798 13.6425 3.41274 13.6424 3.49121V13.9355Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M6 10.5L9.5 14.8889H27V19C27 20.1046 26.1046 21 25 21H10C7.79086 21 6 19.2091 6 17L6 10.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M5.08331 17.5V7C5.08331 5.87283 5.5314 4.79215 6.32843 3.99512C7.12546 3.19809 8.20614 2.75 9.33331 2.75H13.928L14.1898 2.75977C14.799 2.8005 15.3934 2.97169 15.9319 3.26367L16.1566 3.39453C16.6683 3.71393 17.1071 4.13913 17.4427 4.64258L18.3939 6.03516L18.3978 6.04102L18.4085 6.05762L18.4124 6.0625L18.4788 6.14062C18.5038 6.16351 18.5318 6.18294 18.5618 6.19922L18.6566 6.2373C18.6893 6.24571 18.7231 6.24974 18.7571 6.25H23.3333C24.4605 6.25 25.5412 6.69809 26.3382 7.49512L26.4837 7.64746C27.1897 8.4271 27.5833 9.44323 27.5833 10.5V17.5C27.5833 18.5568 27.1897 19.5729 26.4837 20.3525L26.3382 20.5049C25.5412 21.3019 24.4605 21.75 23.3333 21.75H9.33331C6.99143 21.75 5.08331 19.8419 5.08331 17.5ZM6.58331 17.5C6.58331 19.0135 7.81986 20.25 9.33331 20.25H23.3333C24.0627 20.25 24.7619 19.9601 25.2776 19.4443L25.4603 19.2432C25.8614 18.7538 26.0833 18.1383 26.0833 17.5V10.5C26.0833 9.86168 25.8614 9.24624 25.4603 8.75684L25.2776 8.55566C24.7619 8.03994 24.0627 7.75 23.3333 7.75H18.7464C18.5107 7.74828 18.2781 7.70287 18.0599 7.61719L17.847 7.51855C17.5695 7.3681 17.3331 7.15132 17.1595 6.8877V6.88672L17.1556 6.88184L16.2044 5.48926L16.1985 5.48047C15.9499 5.10543 15.6128 4.79655 15.2171 4.58203C14.8688 4.39318 14.4842 4.28227 14.0901 4.25586L13.9202 4.25H9.33331C8.60397 4.25 7.9047 4.53994 7.38898 5.05566C6.87325 5.57139 6.58331 6.27065 6.58331 7V17.5Z"
      fill="#474C5E"
    />
    <path
      d="M0.416641 22.1663V9.33325C0.416641 8.91904 0.752428 8.58325 1.16664 8.58325C1.58085 8.58325 1.91664 8.91904 1.91664 9.33325V22.1663C1.91664 23.6797 3.15319 24.9163 4.66664 24.9163H20.9996L21.0768 24.9202C21.4548 24.9586 21.7495 25.2781 21.7496 25.6663C21.7496 26.0545 21.4549 26.3739 21.0768 26.4124L20.9996 26.4163H4.66664C2.32476 26.4163 0.416641 24.5081 0.416641 22.1663Z"
      fill="#474C5E"
    />
  </svg>
)

const WorkforceSection: FCC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('allFeature:workforce:section_1_content_title'),
      iconType: ICON_1,
      contentDescription: t(
        'allFeature:workforce:section_1_content_description'
      ),
      contentImage: '/img/feature/lp/new/talent-intelligence-workforce01.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:workforce:section_2_content_title'),
      iconType: ICON_2,
      contentDescription: t(
        'allFeature:workforce:section_2_content_description'
      ),
      contentImage: '/img/feature/lp/new/talent-intelligence-workforce02.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:workforce:section_3_content_title'),
      iconType: ICON_3,
      contentDescription: t(
        'allFeature:workforce:section_3_content_description'
      ),
      contentImage: '/img/feature/lp/new/talent-intelligence-workforce03.png',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="allFeature:workforce:title"
      description="allFeature:workforce:description"
      tagLabel="allFeature:workforce:tag"
      tagColor="bg-blue-100 text-blue-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <div className="relative">
        <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
        <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
        <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
        <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
        <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="flex flex-col tablet:flex-row tablet:flex-wrap align-middle w-full justify-center mt-6 border-gray-100 border border-r-0 border-b-0">
          {SECTIONS.map((item, index) => (
            <div
              key={index}
              className="flex-1 border-gray-100 border-r border-b relative">
              <div className="absolute right-6 top-5">{item.iconType}</div>
              <div className="mt-12">
                <Image
                  src={item.contentImage}
                  width={544}
                  height={0}
                  alt={`${item.contentImage}-image`}
                  className="h-auto"
                />
              </div>
              <div className="mt-6 mb-8 px-6">
                <TypographyText className="text-[23px] font-medium text-gray-900">
                  {item.contentTitle}
                </TypographyText>
                <TypographyText className="text-base font-normal text-gray-700 mt-1">
                  {item.contentDescription}
                </TypographyText>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default WorkforceSection
